import * as React from 'react';
import { Button } from 'react-bootstrap';
import { openOnBaseImage } from '../../../services/documentDownloadService';
import { getFormData } from './redux-objects/actions';
import { connect } from 'react-redux';

interface IViewTvalButtonProps {
  reportId: number;
  data: any;
  buttonText: string;
  className: string;
  getFormData?: (reportId: number) => Promise<void>;
}

const ViewTvalButton: React.FunctionComponent<IViewTvalButtonProps> = (
  props
) => {
  const openTval = (e: any, reportId: number) => {
    props.getFormData(reportId).then(() => {
      console.log('data from button', props.data);
      const url = '/ViewTval';
      window.open(url, '_blank', 'width=1300,height=900');
    });
  };

  return (
    <Button
      className={props.className}
      variant='outline-primary'
      size='sm'
      data-id={props.reportId}
      onClick={() => openTval(null, props.reportId)}
    >
      {props.buttonText}
    </Button>
  );
};

const mapStateToProps = (reduxState: any) => {
  return { data: reduxState.ViewTval.data };
};

const mapDispatchToProps = {
  getFormData,
};

export default connect<any, IViewTvalButtonProps>(
  mapStateToProps,
  mapDispatchToProps
)(ViewTvalButton);
